import * as C from './common';

import { default_experience_key } from '../../../constants';

export default ({
  arms,
  initialValues,
  nodeSlugs,
  experience = default_experience_key,
}) => {
  return [
    [{ name: `content`, input: [C.title, C.reminderType, C.emit_event] }],
  ];
};

export const add_reminder_outgoing = data => {
  return data;
};

export const add_reminder_incoming = data => {
  return data;
};
